import store from './store'
import moment from 'moment'
// convierte una fecha de AAAA-MM-DD a DD/MM/AAAA
export function formatDate (date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}
// convierte una fecha de DD/MM/AAAA a AAAA-MM-DD
export function parseDate (date) {
  if (!date) return null
  const [day, month, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}
// actualiza el numero de los dias de la semana actual
export function actualziarFechas () {
  store.state.lunes = moment(new Date()).startOf('week').add(1, 'days').format('DD')
  store.state.martes = moment(new Date()).startOf('week').add(2, 'days').format('DD')
  store.state.miercoles = moment(new Date()).startOf('week').add(3, 'days').format('DD')
  store.state.jueves =  moment(new Date()).startOf('week').add(4, 'days').format('DD')
  store.state.viernes = moment(new Date()).startOf('week').add(5, 'days').format('DD')
  store.state.sabado = moment(new Date()).startOf('week').add(6, 'days').format('DD')
  store.state.actual = moment(new Date()).format('DD')
}